import { Dispatch, SetStateAction, useContext, useState } from 'react';

import { endpoints } from '@/API/endpoints';
import { UserRoleContext } from '@/context/RoleContext';
import DateInput from '@/forms/components/simpleWidgets/date-input/DateInput';
import SelectWrapper from '@/forms/components/simpleWidgets/select-input/SelectWrapper';
import TextInput from '@/forms/components/simpleWidgets/text-input/TextInput';
import TimeInput from '@/forms/components/simpleWidgets/time-input/TimeInput';
import { dateToRFC } from '@/helpers/dates';
import { useApi } from '@/hooks/useApi/useApi';
import { PatchDataType } from '@/types';

import classes from './TableDesktop.module.scss';

type TTableDesktopProps = {
	setUpdateTable: Dispatch<SetStateAction<boolean>>;
	setIsFormOpen: Dispatch<SetStateAction<boolean>>;
};

const TableDesktop = ({
	setUpdateTable,
	setIsFormOpen,
}: TTableDesktopProps) => {
	const [formInputs, setFormInputs] = useState<PatchDataType>({
		task: null,
		project: null,
		date: null,
		action_type: null,
		spent_time_min: null,
	});

	const { userRoleContext } = useContext(UserRoleContext);
	const { apiPost } = useApi();

	const onSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		const loggingData = Object.assign({}, formInputs, {
			date: formInputs.date
				? dateToRFC(new Date(formInputs.date as string | number | Date))
				: dateToRFC(new Date()),
		});
		const res = await apiPost(
			endpoints.addUserLogging,
			loggingData,
			undefined,
			true
		);

		if (res.data) {
			setUpdateTable(true);
			setIsFormOpen((prev) => !prev);
		}
	};

	return (
		<form id='LoggingForm' className={classes.form} onSubmit={onSubmit}>
			<TextInput
				name='textInputLogging'
				value={''}
				placeholder={'Название задачи'}
				onChange={(value) => {
					setFormInputs({
						...formInputs,
						task: value,
					});
				}}
			/>
			<SelectWrapper
				name='selectLogging'
				onChange={(value) => {
					setFormInputs({
						...formInputs,
						project: value,
					});
				}}
				placeholder={'Выбрать проект'}
				choices={undefined}
				choices_url='api/project/project_time_tracking/create_form/choices/project/'
			/>
			<DateInput
				name='dateLogging'
				onChange={(value) => {
					setFormInputs({
						...formInputs,
						date: value,
					});
				}}
				value={null}
				placeholder={''}
				disabled={
					userRoleContext.data.can_choose_date_project_time_tracking
						? false
						: true
				}
			/>
			<SelectWrapper
				name='selectLogging'
				onChange={(value) => {
					setFormInputs({
						...formInputs,
						action_type: value,
					});
				}}
				placeholder={'Тип работы'}
				choices_url={'api/project/action_type'}
			/>
			<TimeInput
				name='timeInputLogging'
				value=''
				onChange={(value) => {
					setFormInputs({
						...formInputs,
						spent_time_min: value,
					});
				}}
			/>
			<SelectWrapper
				name='taskStatus'
				onChange={(value) => {
					setFormInputs({
						...formInputs,
						task_status: value,
					});
				}}
				choices_url={`api/project/project_status_list${
					formInputs.project ? `?project=${formInputs.project}` : ''
				}`}
				placeholder={'Цель задачи'}
				autoFocus={true}
			/>
			<button type={'submit'} form={'LoggingForm'} className={classes.formBtn}>
				{' '}
			</button>
		</form>
	);
};

export default TableDesktop;
